import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { customerLocation, regions, cities, countries } from "../constants/customer";

export const addCustomerLocation = async (bodyData) => {
  try {
    const res = await api.add_customer_location(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
}

export const getCustomerLocationList = async (dispatch, customerID, pageNum, filters, searchString) => {
  try {
    const res = await api.customer_location_list(customerID, pageNum, filters, searchString);
    dispatch({ type: customerLocation, payload: res.data });
  } catch (error) {
    dispatch({ type: customerLocation, payload: error?.response?.data || error });
    authorizedUser(error?.response?.data);
  }
};

export const getCustomerLocationById = async (customerID, locationID) => {
  try {
    const res = await api.customer_location_by_id(customerID, locationID);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}

export const editCustomerLocation = async (customerID, bodyData) => {
  try {
    const res = await api.edit_customer_location(customerID, bodyData);
    return res.data;
  }
  catch (error) {
    return error?.response?.data || error;
  }
}

export const deleteCustomerLocation = async (customerID, locationID) => {
  try {
    const res = await api.delete_customer_location(customerID, locationID);
    return res.data;
  }
  catch (error) {
    return error?.response?.data || error;
  }
}

export const getRegions = async (dispatch) => {
  try {
    const res = await api.region_list();
    dispatch({ type: regions, payload: res.data.data });
  } catch (error) {
    dispatch({ type: regions, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
}

export const getCities = async (dispatch, filtersJSON) => {
  try {
    const res = await api.city_list(filtersJSON);
    dispatch({ type: cities, payload: res.data.data });
  } catch (error) {
    dispatch({ type: cities, payload: error?.response?.data || error });
    authorizedUser(error?.response?.data);
  }
};

export const getCountries = async (dispatch) => {
  try {
    const res = await api.country_list();
    dispatch({ type: countries, payload: res.data.data });
  } catch (error) {
    dispatch({ type: countries, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
}
